import React from 'react';
import { DumbbellIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductArtwork } from './ProductArtwork';
import { PRODUCT_NAME } from './constants';
export function Hero() {
  return <section className="border-b border-line bg-white px-4 py-5 sm:py-7" data-id="element-91" data-mp="9l341bdfia3g">
      <div className="mx-auto max-w-3xl text-center" data-id="element-92" data-mp="4mrteyfb7vk6">
        <div className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-sport/50 bg-sport/10 px-3 py-1 text-[11px] font-display font-bold tracking-wide text-navy" data-id="element-93" data-mp="129h2fs8fj8fj">
          <DumbbellIcon className="h-3.5 w-3.5 text-sport" aria-hidden="true" data-id="element-94" data-mp="x8b7rov7lb3d" />
          COMPLETE 6-IN-1 COACHING SYSTEM
        </div>
        <h1 className="font-extrabold text-navy sm:text-4xl text-[20px]" data-id="element-95" data-mp="ncq1hej3xont">
          The Complete Planning System for Strength &amp; Conditioning Coaches
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-graphite sm:text-base" data-id="element-96" data-mp="3czfoc8080na9">
          Save hours planning training sessions, building strength programs,
          organizing season plans, developing performance progressions, and
          preparing professional coaching resources—without creating every
          workout from scratch.
        </p>
        <div className="my-3 inline-block rounded-md bg-navy px-3 py-1.5 font-display text-xs font-bold tracking-wide text-white" data-id="element-97" data-mp="399jppk78yr9a">
          💪 {PRODUCT_NAME} — Complete 6-in-1 Planning System for Strength &amp;
          Conditioning Coaches
        </div>
        <ProductArtwork className="mx-auto max-w-md drop-shadow-2xl" data-id="element-98" data-mp="358ho4wpuy345" />
        <div className="mx-auto mt-3 max-w-md" data-id="element-99" data-mp="35au9ljutqvly">
          <CTAButton data-id="element-100" data-mp="2qkmune40zuq0">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
        </div>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-bold text-navy" data-id="element-101" data-mp="2viol4k3s6wbi">
          <span className="inline-flex items-center gap-1" data-id="element-102" data-mp="2hix224yeqpqn">
            <StarIcon className="h-4 w-4 fill-sport text-sport" aria-hidden="true" data-id="element-103" data-mp="2hljb690y5daz" />
            4.9/5 — Verified Coach Reviews
          </span>
          <span className="hidden text-line sm:inline" data-id="element-104" data-mp="s44ghj521dfs">•</span>
          <span className="inline-flex items-center gap-1" data-id="element-105" data-mp="na9z4mcx9ajv">
            <ShieldCheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-106" data-mp="ic891hh2wayw" />
            7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}